module.exports = __webpack_public_path__ + "img/KON2.ea319e46.jpeg";